import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, dataToJS, pathToJS } from 'react-redux-firebase';

import SectionSelector from './component';

export default compose(firebaseConnect(['sections']), connect(({ firebase }) => ({
  sections: dataToJS(firebase, 'sections') || {},
  auth: pathToJS(firebase, 'auth'),
})))(SectionSelector);



// WEBPACK FOOTER //
// ./src/modules/SectionSelector/container.js